import React, { useCallback, useEffect, useState } from 'react';
import { BiPlus } from 'react-icons/bi';
import { AiOutlineMinus } from 'react-icons/ai';

import {
  AcorddionContainer,
  AccordionTitle,
  AccordionBody,
  Container,
  TitleWrap,
  FaqNotFound,
} from './styles';
import InputSearch from './InputSearch';
import { faqProvider } from './provider';

function Faq() {
  const [showContent, setShowContent] = useState([0]);
  const [searchValue, setSearchValue] = useState('');
  const [listItems, setListItems] = useState([]);

  useState(() => {
    if (listItems?.length > 0) return;
    setListItems(faqProvider);
  }, [faqProvider, listItems, setListItems]);

  function handleShowContent(id) {
    setShowContent((old) => [...old, id]);
  }

  const handleRemoveShowContent = useCallback(
    (id) => {
      const newContent = showContent.filter((content) => content !== id);
      setShowContent([...newContent]);
    },
    [showContent, setShowContent]
  );

  useEffect(() => {
    // @ts-ignore
    Array.prototype.unique = function () {
      const a = this.concat();
      for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
          if (a[i] === a[j]) a.splice(j--, 1);
        }
      }

      return a;
    };
    if (searchValue?.length) {
      const searchTitle = faqProvider.filter((faqItem) =>
        faqItem?.title?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );

      const searchBody = faqProvider.filter((faqItem) =>
        faqItem?.contentString
          ?.toLowerCase()
          ?.includes(searchValue?.toLowerCase())
      );

      const searchItems = searchTitle.concat(searchBody).unique();
      setListItems([...searchItems]);
    } else {
      setListItems(faqProvider);
    }
  }, [searchValue]);

  return (
    <Container>
      <InputSearch setSearchValue={setSearchValue} searchValue={searchValue} />
      <>
        {listItems?.length > 0 &&
          listItems.map((faq) => (
            <AcorddionContainer key={faq.id}>
              <TitleWrap
                onClick={() => {
                  if (showContent.includes(faq.id)) {
                    handleRemoveShowContent(faq.id);
                  } else {
                    handleShowContent(faq.id);
                  }
                }}
              >
                <AccordionTitle>{`${faq.id} - ${faq.title}`}</AccordionTitle>
                {showContent.includes(faq.id) ? (
                  <AiOutlineMinus color="#000eff" size={16} />
                ) : (
                  <BiPlus color="#000eff" size={16} />
                )}
              </TitleWrap>
              <AccordionBody showBody={showContent.includes(faq.id)}>
                {faq.content}
              </AccordionBody>
            </AcorddionContainer>
          ))}
        {listItems.length === 0 && (
          <FaqNotFound>
            Não existe nenhum resultado para essa busca.
          </FaqNotFound>
        )}
      </>
    </Container>
  );
}

export default Faq;
